import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { FaqSectionStore, FaqSectionState } from './faq-section.store';

@Injectable({ providedIn: 'root' })
export class FaqSectionQuery extends QueryEntity<FaqSectionState> {
  constructor(protected store: FaqSectionStore) {
    super(store);
  }
}
